import React, { useState, useEffect } from "react";
import "./CSS/Point.css";
import {
  add_points,
  edit_points,
  remove_points,
  set_tag_ids,
  set_tag_list,
  set_tags_for_trend_page,
  setTotalizerTags,
} from "../Action/Action";
import { connect } from "react-redux";
import Store from "../Store/Store";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { act } from "react";
import axiosInstance from "../services/axiosConfig";

const Point = (props) => {
  const history = useHistory();

  const [alert, Setalert] = useState("");
  const [tag_page_number, Set_tag_page_number] = useState(1);

  const [flowcontrol, Setflowcontrol] = useState(false);

  const [detailobj, Setdetailobj] = useState(null);

  //yetkilendirme
  const [tag_yazma_control, Set_tag_yazma_control] = useState(false);
  const [tag_silme_control, Set_tag_silme_control] = useState(false);

  useEffect(() => {
    if (props.yetkilendirme && props.userId !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.userId];
      if (newObj !== undefined) {
        if (newObj["İletişim"]["Y"] === "t") {
          Set_tag_yazma_control(true);
        } else {
          Set_tag_yazma_control(false);
        }
        if (newObj["İletişim"]["S"] === "t") {
          Set_tag_silme_control(true);
        } else {
          Set_tag_silme_control(false);
        }
      }

    }
  }, [props.yetkilendirme]);

  const [inp1, Setinp1] = useState("");
  const [inp2, Setinp2] = useState(0);
  const [inp3, Setinp3] = useState(0);
  const [inp4, Setinp4] = useState(0);
  const [inp5, Setinp5] = useState("");
  const [inp6, Setinp6] = useState("");

  const [ucer_id, SetUcer_ID] = useState(() => {
    var _ucer = sessionStorage.getItem("ucer_id");
    var json_ucer;
    if (_ucer) {
      json_ucer = JSON.parse(_ucer);
      json_ucer = Number(json_ucer);
      return json_ucer;
    }
  });

  useEffect(() => {
    console.log(detailobj);
  }, [detailobj]);

  useEffect(() => {
    document.querySelector("section.point_section").style.zoom = "90%";
  }, []);

  useEffect(() => {
    if (tag_page_number === 1) {
      document
        .querySelector(".left_arrow_changex-45")
        .classList.toggle("left_arrow_changex-45_inactive");
    } else {
      if (
        document
          .querySelector(".left_arrow_changex-45")
          .classList.contains("left_arrow_changex-45_inactive")
      ) {
        document
          .querySelector(".left_arrow_changex-45")
          .classList.remove("left_arrow_changex-45_inactive");
      }
    }
  }, [tag_page_number]);

  const [path, Setpath] = useState("");

  useEffect(() => {
    let path_ = window.location.pathname;
    Setpath(path_);
  }, []);

  const [edit_id, Set_edit_id] = useState(null);
  const [edit_type, Set_edit_type] = useState(null);
  const [edit_point_address, Set_edit_point_address] = useState(null);
  const [edit_point_name, Set_edit_point_name] = useState(null);
  const [edit_point_decimal, Set_edit_point_decimal] = useState(null);

  const [edit_point_name2, Set_edit_point_name2] = useState(null);
  const [edit_original_name, Set_edit_original_name] = useState(null); // Orijinal tag adı (tagName2)

  const [edit_point_address2, Set_edit_point_address2] = useState(0);
  const [edit_birim, Set_edit_birim] = useState("");
  const [edit_point_formula, Set_edit_point_formula] = useState("");
  const [edit_point_db_number, Set_edit_point_db_number] = useState(0);

  const [activeTagId, Set_activeTagId] = useState(null);

  const onEditFormSubmit = async (e) => {
    e.preventDefault();
    // var obj = {
    //   "TagName": edit_point_name,
    //   "TagDbNumber": edit_point_db_number,
    //   "TagAddress": edit_point_address,
    //   "TagAddressDetail": edit_point_address2,
    //   "TagFormula": edit_point_formula,
    //   "TagUnit": edit_birim,
    //   "TagDataType": 1,
    //   "TagType": 1,
    //   "TagPlc": 1,
    //   "TagModule": 1,
    //   "TagChannel": 1,
    //   "companyId": ucer_id,
    //   "TagId": Number(edit_id)
    // }

    // var obj_reducer = {
    //   "tagName": edit_point_name,
    //   "tagDbNumber": edit_point_db_number,
    //   "tagAddress": edit_point_address,
    //   "tagAddressDetail": edit_point_address2,
    //   "tagFormula": edit_point_formula,
    //   "tagUnit": edit_birim,
    //   "tagDataType": 1,
    //   "tagType": 1,
    //   "tagPlc": 1,
    //   "tagModule": 1,
    //   "tagChannel": 1,
    //   "companyId": ucer_id,
    //   "tagId": String(edit_id)
    // }

    // const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/EditTag", {
    //   headers: {
    //     "Content-Type": "application/json",
    //     "Accept": "application/json"
    //   },
    //   method: "POST",
    //   body: JSON.stringify(obj)
    // })

    // const response = await request.json();

    // console.log(response);

    // if (request.status === 200) {
    //   await Store.dispatch(edit_points(String(edit_id), obj_reducer))

    //   let alert_box = document.querySelector("#alert-box");
    //   alert_box.classList.add("alert_edit");
    //   alert_box.classList.add("alert-box-active")
    //   Setalert(`${edit_point_name} was updated successfully`)

    //   setTimeout(() => {
    //     alert_box.classList.remove("alert_edit")
    //     alert_box.classList.remove("alert-box-active")
    //     Setalert("")
    //   }, 4000);

    //   var pop_up = document.querySelector(".edit_point_pop_up")
    //   var point_seciton = document.querySelector("section.point_section")
    //   if (point_seciton.classList.contains("point_section_dark")) point_seciton.classList.remove("point_section_dark")

    //   if (pop_up.classList.contains("edit_point_pop_up_active")) {
    //     pop_up.classList.remove("edit_point_pop_up_active")
    //   }
    // }

    if (edit_point_name !== "" && activeTagId !== null) {
      try {
        const request = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/tags/ChangeTagName",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            method: "POST",
            body: JSON.stringify({
              TagName2: edit_point_name,
              TagId: activeTagId,
              companyId:Number(props.temp_com_id)
            }),
          }
        );
        const response = await request.json();

        if (request.status === 200) {
          var sort_strings = [];
          response.forEach((i) => {
            sort_strings.push(i.tagName);
          });
          sort_strings.sort();

          let new_sorted_array = [];
          sort_strings.forEach((k) => {
            for (let j = 0; j < response.length; j++) {
              if (response[j].tagName === k) {
                new_sorted_array.push(response[j]);
                continue;
              }
            }
          });
          const uniqueById_widget = new_sorted_array.reduce((unique, item) => {
            // Her öğeyi klonlayarak yeni bir nesne oluşturun
            const newItem = { ...item };
          
            // Şartlara göre tagName ve tagName2 değerlerini değiştirin
            if (newItem.tagName2 && newItem.tagName2 !== null && newItem.tagName2 !== "") {
              let old_name = newItem.tagName;
              newItem.tagName = newItem.tagName2;
              newItem.tagName2 = old_name;
            }
          
            // Eşsiz öğeleri tagId'ye göre kontrol edip ekleyin
            if (!unique.some((obj) => obj.tagId === newItem.tagId)) {
              unique.push(newItem);
            }
          
            return unique;
          }, []);

          Store.dispatch(set_tag_list(uniqueById_widget));
        }
      } catch (err) {
        console.error("Error: ", err);
      } finally {
        var pop_up = document.querySelector(".edit_point_pop_up");
        var point_seciton = document.querySelector("section.point_section");
        if (point_seciton.classList.contains("point_section_dark"))
          point_seciton.classList.remove("point_section_dark");

        if (pop_up.classList.contains("edit_point_pop_up_active")) {
          pop_up.classList.remove("edit_point_pop_up_active");
        }
      }
    }

    if (edit_point_name2 !== "" && activeTagId !== null) {
      try {
        const request = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/tags/ChangeTagDescripton",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            method: "POST",
            body: JSON.stringify({
              TagName3: edit_point_name,
              TagId: activeTagId,
              companyId:Number(props.temp_com_id)

            }),
          }
        );
        const response = await request.json();

        if (request.status === 200) {
          var sort_strings = [];
          response.forEach((i) => {
            sort_strings.push(i.tagName);
          });
          sort_strings.sort();

          let new_sorted_array = [];
          sort_strings.forEach((k) => {
            for (let j = 0; j < response.length; j++) {
              if (response[j].tagName === k) {
                new_sorted_array.push(response[j]);
                continue;
              }
            }
          });
          const uniqueById_widget = new_sorted_array.reduce((unique, item) => {
            if (
              item.tagName2 &&
              item.tagName2 !== null &&
              item.tagName2 !== ""
            ) {
              let old_name = item.tagName;
              item.tagName = item.tagName2;
              item.tagName2 = old_name;
            }
            if (!unique.some((obj) => obj.tagId === item.tagId)) {
              unique.push(item);
            }
            return unique;
          }, []);

          Store.dispatch(set_tag_list(uniqueById_widget));
        }
      } catch (err) {
        console.error("Error: ", err);
      } finally {
        var pop_up = document.querySelector(".edit_point_pop_up");
        var point_seciton = document.querySelector("section.point_section");
        if (point_seciton.classList.contains("point_section_dark"))
          point_seciton.classList.remove("point_section_dark");

        if (pop_up.classList.contains("edit_point_pop_up_active")) {
          pop_up.classList.remove("edit_point_pop_up_active");
        }
      }
    }

    if (edit_point_decimal !== "" && activeTagId !== null) {
      try {
        const request = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/tags/ChangeTagDecimal",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            method: "POST",
            body: JSON.stringify({
              TagDecimal: edit_point_decimal,
              TagId: activeTagId,
              companyId:Number(props.temp_com_id)

            }),
          }
        );
        const response = await request.json();

        if (request.status === 200) {
          var sort_strings = [];
          response.forEach((i) => {
            sort_strings.push(i.tagName);
          });
          sort_strings.sort();

          let new_sorted_array = [];
          sort_strings.forEach((k) => {
            for (let j = 0; j < response.length; j++) {
              if (response[j].tagName === k) {
                new_sorted_array.push(response[j]);
                continue;
              }
            }
          });
          const uniqueById_widget = new_sorted_array.reduce((unique, item) => {
            if (
              item.tagName2 &&
              item.tagName2 !== null &&
              item.tagName2 !== ""
            ) {
              let old_name = item.tagName;
              item.tagName = item.tagName2;
              item.tagName2 = old_name;
            }
            if (!unique.some((obj) => obj.tagId === item.tagId)) {
              unique.push(item);
            }
            return unique;
          }, []);

          Store.dispatch(set_tag_list(uniqueById_widget));
        }
      } catch (err) {
        console.error("Error: ", err);
      } finally {
        var pop_up = document.querySelector(".edit_point_pop_up");
        var point_seciton = document.querySelector("section.point_section");
        if (point_seciton.classList.contains("point_section_dark"))
          point_seciton.classList.remove("point_section_dark");

        if (pop_up.classList.contains("edit_point_pop_up_active")) {
          pop_up.classList.remove("edit_point_pop_up_active");
        }
      }
    }
  };

  const OnChangeinp1 = (e) => {
    Setinp1(e.target.value);
  };
  const OnChangeinp2 = (e) => {
    Setinp2(Number(e.target.value));
  };
  const OnChangeinp3 = (e) => {
    Setinp3(Number(e.target.value));
  };
  const OnChangeinp4 = (e) => {
    Setinp4(Number(e.target.value));
  };
  const OnChangeinp5 = (e) => {
    Setinp5(e.target.value);
  };
  const OnChangeinp6 = (e) => {
    Setinp6(e.target.value);
  };

  const OnChangeinp1_1 = (e) => {
    Set_edit_point_name(e.target.value);
  };
  const OnChangeinp1_3 = (e) => {
    Set_edit_point_decimal(e.target.value);
  };
  const OnChangeinp1_2 = (e) => {
    Set_edit_point_name2(e.target.value);
  };
  const OnChangeinp2_2 = (e) => {
    Set_edit_point_address(Number(e.target.value));
  };
  const OnChangeinp3_3 = (e) => {
    Set_edit_point_address2(Number(e.target.value));
  };
  const OnChangeinp4_4 = (e) => {
    Set_edit_point_db_number(Number(e.target.value));
  };
  const OnChangeinp5_5 = (e) => {
    Set_edit_point_formula(e.target.value);
  };
  const OnChangeinp6_6 = (e) => {
    Set_edit_birim(e.target.value);
  };

  const open_add_pop_up = () => {
    var pop_up = document.querySelector(".add_point_pop_up");

    var point_seciton = document.querySelector("section.point_section");

    if (!point_seciton.classList.contains("point_section_dark"))
      point_seciton.classList.add("point_section_dark");

    if (!pop_up.classList.contains("add_point_pop_up_active")) {
      pop_up.classList.add("add_point_pop_up_active");
    }
  };
  const open_edit_pop_up = (e) => {
    Set_edit_id(e.target.parentElement.parentElement.id);
    Set_edit_point_name(
      e.target.parentElement.parentElement.firstElementChild.textContent
    );
    let decimal = props.tag_list
      .filter((x) => x.tagId === e.target.parentElement.parentElement.id)
      .map((x) => x.tagDecimal);
    Set_edit_point_decimal(decimal[0] !== null ? decimal[0] : null);

    let description = props.tag_list
      .filter((x) => x.tagId === e.target.parentElement.parentElement.id)
      .map((x) => x.tagName3);
    Set_edit_point_name2(description[0] !== null ? description[0] : null);

    // Orijinal tag adını al (tagName2)
    let originalName = props.tag_list
      .filter((x) => x.tagId === e.target.parentElement.parentElement.id)
      .map((x) => x.tagName2);
    Set_edit_original_name(originalName[0] !== null ? originalName[0] : null);

    Set_edit_type(
      Number(
        e.target.parentElement.parentElement.firstElementChild
          .nextElementSibling.textContent
      )
    );
    Set_edit_point_address(
      Number(
        e.target.parentElement.parentElement.firstElementChild
          .nextElementSibling.nextElementSibling.textContent
      )
    );
    Set_edit_point_db_number(
      Number(
        e.target.parentElement.parentElement.firstElementChild
          .nextElementSibling.nextElementSibling.nextElementSibling.textContent
      )
    );

    var pop_up = document.querySelector(".edit_point_pop_up");
    var point_seciton = document.querySelector("section.point_section");

    if (!point_seciton.classList.contains("point_section_dark"))
      point_seciton.classList.add("point_section_dark");

    if (!pop_up.classList.contains("edit_point_pop_up_active")) {
      pop_up.classList.add("edit_point_pop_up_active");
    }
  };

  const close_add_pop_up = () => {
    Set_edit_id(null);
    Set_edit_point_name(null);
    Set_edit_point_name2(null);
    Set_edit_original_name(null);

    Set_edit_point_address(null);
    Set_edit_point_address2(null);
    Set_edit_point_db_number(null);
    Set_edit_birim(null);
    Set_edit_point_formula(null);
    var pop_up = document.querySelector(".add_point_pop_up");
    var point_seciton = document.querySelector("section.point_section");
    if (point_seciton.classList.contains("point_section_dark"))
      point_seciton.classList.remove("point_section_dark");

    if (pop_up.classList.contains("add_point_pop_up_active")) {
      pop_up.classList.remove("add_point_pop_up_active");
    }
  };
  const close_edit_pop_up = () => {
    var pop_up = document.querySelector(".edit_point_pop_up");
    var point_seciton = document.querySelector("section.point_section");
    if (point_seciton.classList.contains("point_section_dark"))
      point_seciton.classList.remove("point_section_dark");

    if (pop_up.classList.contains("edit_point_pop_up_active")) {
      pop_up.classList.remove("edit_point_pop_up_active");
    }
  };

  const removetag = async (e) => {
    const request = await fetch(
      "https://app-rmmsapi.azurewebsites.net/api/tags/DeleteTag",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify({
          TagId: Number(e.target.parentElement.parentElement.id),
        }),
      }
    );

    if (request.status === 200) {
      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_delete");
      alert_box.classList.add("alert-box-active");
      Setalert(
        `${e.target.parentElement.parentElement.firstElementChild.textContent} was deleted successfully`
      );

      setTimeout(() => {
        alert_box.classList.remove("alert_delete");
        alert_box.classList.remove("alert-box-active");
        Setalert("");
      }, 4000);
    }
  };
  useEffect(() => {
    console.log(props.tags_for_trend_page);
  }, [props.tags_for_trend_page]);
  const OnFormSubmit = async (e) => {
    e.preventDefault();
    var obj = {
      TagName: inp1,
      TagDbNumber: inp4,
      TagAddress: inp2,
      TagAddressDetail: inp3,
      TagFormula: inp5,
      TagUnit: inp6,
      TagDataType: 1,
      TagType: 1,
      TagPlc: 1,
      TagModule: 1,
      TagChannel: 1,
      companyId: props.temp_com_id,
    };

    var obj_reducer = {
      tagName: inp1,
      tagDbNumber: inp4,
      tagAddress: inp2,
      tagAddressDetail: inp3,
      tagFormula: inp5,
      tagUnit: inp6,
      tagDataType: 1,
      tagType: 1,
      tagPlc: 1,
      tagModule: 1,
      tagChannel: 1,
      companyId: props.temp_com_id,
    };

    console.log(obj);

    const request = await fetch(
      "https://app-rmmsapi.azurewebsites.net/api/tags/AddTag",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify(obj),
      }
    );

    const response = await request.json();

    console.log(response);

    if (request.status === 200) {
      await Store.dispatch(add_points(obj_reducer));

      let alert_box = document.querySelector("#alert-box");
      alert_box.classList.add("alert_add");
      alert_box.classList.add("alert-box-active");
      Setalert(`${inp1} was added successfully`);

      setTimeout(() => {
        alert_box.classList.remove("alert_add");
        alert_box.classList.remove("alert-box-active");
        Setalert("");
      }, 4000);

      var pop_up = document.querySelector(".add_point_pop_up");
      var point_seciton = document.querySelector("section.point_section");
      if (point_seciton.classList.contains("point_section_dark"))
        point_seciton.classList.remove("point_section_dark");

      if (pop_up.classList.contains("add_point_pop_up_active")) {
        pop_up.classList.remove("add_point_pop_up_active");
      }

      Setinp1("");
      Setinp2(0);
      Setinp3(0);
      Setinp4(0);
      Setinp5("");
      Setinp6("");
    }
  };

  const detail_pop_up_active = (item) => {
    var control = null;
    if (item !== null) {
      Setdetailobj(item);
      control = true;
    }
    if (control == true) {
      document
        .querySelector(".detail_pop_up_tag")
        .classList.toggle("detail_pop_up_tag_active");
      var point_seciton = document.querySelector("section.point_section");
      point_seciton.classList.toggle("point_section_dark");
    }
  };

  const close_detail = () => {
    document
      .querySelector(".detail_pop_up_tag")
      .classList.toggle("detail_pop_up_tag_active");
    var point_seciton = document.querySelector("section.point_section");
    point_seciton.classList.toggle("point_section_dark");
  };

  const [filtre_tagName, Set_filtre_tagName] = useState("");

  const onChangeFiltrelemeValue = (e) => {
    e.preventDefault();
    Set_filtre_tagName(e.target.value);
    let data = props.tag_list;
    let newdata = [];
    data.forEach((x) => {
      if (x.tagName.includes(e.target.value)) {
        newdata.push(x);
      }
    });
    Set_render_state(newdata);
  };
  const [filtre_tagAddress, Set_filtre_tagAddress] = useState("");

  const onChangeFiltrelemeValue2 = (e) => {
    e.preventDefault();
    Set_filtre_tagAddress(e.target.value);
    let data = props.tag_list;
    let newdata = [];
    data.forEach((x) => {
      if (String(x.tagAddress).includes(e.target.value)) {
        newdata.push(x);
      }
    });
    Set_render_state(newdata);
  };
  const [filtre_tagId, Set_filtre_tagId] = useState("");

  const onChangeFiltrelemeValue3 = (e) => {
    e.preventDefault();
    Set_filtre_tagId(e.target.value);
    let data = props.tag_list;
    let newdata = [];
    data.forEach((x) => {
      if (x.tagId.includes(e.target.value)) {
        newdata.push(x);
      }
    });
    Set_render_state(newdata);
  };
  const [filtre_tagType, Set_filtre_tagType] = useState("");

  const onChangeFiltrelemeValue4 = (e) => {
    e.preventDefault();
    Set_filtre_tagType(e.target.value);
    let data = props.tag_list;
    let newdata = [];
    data.forEach((x) => {
      if (String(x.tagType).includes(e.target.value)) {
        newdata.push(x);
      }
    });
    Set_render_state(newdata);
  };

  const [render_state, Set_render_state] = useState([]);

  useEffect(() => {
    Set_render_state(props.tag_list);
    console.log(props.tag_list);
  }, [props.tag_list]);

  const [alarmP_value, Set_alarmP_value] = useState("");

  const OnchangeValue = (e) => {
    Set_alarmP_value(e.target.value);
  };

  const [alarmP_text, Set_alarmP_text] = useState("");

  useEffect(() => { }, []);

  const OnchangeText = (e) => {
    Set_alarmP_text(e.target.value);
  };

  const operators = [">", "=", "<", ">=", "<="];

  const [selectedOperator, setSelectedOperator] = useState("");

  const handleChange = (event) => {
    setSelectedOperator(event.target.value);
  };

  return (
    <>
      <div className="alarmPopup">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
          className="combo-box-tag-alarm-select_operator"
        >
          <label
            style={{
              fontFamily: "sans-serif",
              color: "rgb(70,70,70)",
              fontWeight: "600",
              marginBottom: "16px",
            }}
            htmlFor="operatör"
          >
            Operatör
          </label>

          <select value={selectedOperator} onChange={handleChange}>
            <option value="" disabled>
              Operatör Seçin
            </option>
            {operators.map((operator) => (
              <option key={operator} value={operator}>
                {operator}
              </option>
            ))}
          </select>
        </div>
        <div className="AlarmMessageArea">
          <label htmlFor="value" className="alarm-label">
            Değer
          </label>
          <input
            className="alarm-input"
            placeholder="Alarm değeri"
            onChange={OnchangeValue}
            value={alarmP_value}
            type="text"
          />
        </div>
        <div className="AlarmMessageArea">
          <label htmlFor="msg" className="alarm-label">
            Alarm Mesajı
          </label>
          <textarea
            onChange={OnchangeText}
            value={alarmP_text}
            id="alarm_popup_textarea"
            className="alarm-textarea"
          ></textarea>
        </div>
        <div className="btnPart">
          <button
            onClick={() => {
              let div_ = document.querySelector(".alarmPopup");
              setSelectedOperator("");
              Set_alarmP_text("");
              Set_alarmP_value("");
              div_.classList.toggle("alarmPopup_active");
              div_.id = "";
              // document
              //   .querySelector(".point_section")
              //   .classList.toggle("point_section_blur");
            }}
          >
            İptal
          </button>
          <button
            onClick={async (e) => {
              try {
                if (
                  alarmP_text !== "" &&
                  alarmP_value !== "" &&
                  selectedOperator !== ""
                ) {
                  let formula_obj = {
                    operator: selectedOperator,
                    value: alarmP_value,
                  };

                  let div_ = document.querySelector(".alarmPopup");
                  let id_ = div_.id;

                  const request = await fetch(
                    "https://app-rmmsapi.azurewebsites.net/api/tags/SetFormula_Alarm",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                      },
                      body: JSON.stringify({
                        Alarm: alarmP_text,
                        TagFormula: JSON.stringify(formula_obj),
                        TagId: id_,
                        companyId: props.com_id,
                      }),
                    }
                  );

                  const response = await request.json();

                  if (request.status === 200) {
                    var sort_strings = [];
                    response.forEach((i) => {
              
                      sort_strings.push(i.tagName);
                    });
                    sort_strings.sort();

                    let new_sorted_array = [];
                    sort_strings.forEach((k) => {
                      for (let j = 0; j < response.length; j++) {
                        if (response[j].tagName === k) {
                          new_sorted_array.push(response[j]);
                          continue;
                        }
                      }
                    });
                    const uniqueById_widget = new_sorted_array.reduce((unique, item) => {
                      if (
                        item.tagName2 &&
                        item.tagName2 !== null &&
                        item.tagName2 !== ""
                      ) {
                        let old_name = item.tagName;
                        item.tagName = item.tagName2;
                        item.tagName2 = old_name;
                      }
                      if (!unique.some((obj) => obj.tagId === item.tagId)) {
                        unique.push(item);
                      }
                      return unique;
                    }, []);

                    console.log(uniqueById_widget);

                    if (response) {
                      Store.dispatch(set_tag_list(uniqueById_widget));
                      let i = 0;
                      let newdata_ = [];
                      while (i < response.length) {
                        newdata_.push({ tagId: response[i].tagId });
                        i++;
                      }
                      await Store.dispatch(set_tag_ids(newdata_));
                      
                    }
                  }
                }
              } catch (err) {
                console.log(err);
              } finally {
                setSelectedOperator("");
                Set_alarmP_text("");
                Set_alarmP_value("");
                let div_ = document.querySelector(".alarmPopup");
                div_.classList.toggle("alarmPopup_active");
                div_.id = "";
                // document
                //   .querySelector(".point_section")
                //   .classList.toggle("pbluroint_section_");
              }
            }}
          >
            Kaydet
          </button>
        </div>
      </div>

      <div className="" id="alert-box">
        {alert}
      </div>
      <div className="detail_pop_up_tag">
        <div className="row">
          <i onClick={close_detail} className="fa fa-times"></i>
        </div>
        <div className="row">
          Tag İsmi: <p>{detailobj !== null ? detailobj.tagName : ""}</p>
        </div>
        {detailobj !== null && detailobj.tagName2 && (
          <div className="row">
            Tag Name Original:{" "}
            <p>{detailobj !== null ? detailobj.tagName2 : ""}</p>
          </div>
        )}

        <div className="row">
          Veri Tabanı Numarası:{" "}
          <p>{detailobj !== null ? detailobj.tagDbNumber : ""}</p>
        </div>
        <div className="row">
          Major Adres: <p>{detailobj !== null ? detailobj.tagAddress : ""}</p>
        </div>
        <div className="row">
          Minor Adres:{" "}
          <p>{detailobj !== null ? detailobj.tagAddressDetail : ""}</p>
        </div>
        <div className="row">
          Formül: <p>{detailobj !== null ? detailobj.tagFormula : ""}</p>
        </div>
        <div className="row">
          Unit: <p>{detailobj !== null ? detailobj.tagUnit : ""}</p>
        </div>
        <div className="row">
          Tip: <p>{detailobj !== null ? detailobj.tagType : ""}</p>
        </div>
        <div className="row">
          Data Tipi: <p>{detailobj !== null ? detailobj.tagDataType : ""}</p>
        </div>
        <div className="row">
          Plc: <p>{detailobj !== null ? detailobj.tagPlc : ""}</p>
        </div>
        <div className="row">
          Modül: <p>{detailobj !== null ? detailobj.tagModule : ""}</p>
        </div>
        <div className="row">
          Kanal: <p>{detailobj !== null ? detailobj.tagChannel : ""}</p>
        </div>
        <div className="row">
          Alarm: <p>{detailobj !== null ? detailobj.alarm : ""}</p>
        </div>
      </div>

      <div className="add_point_pop_up">
        <header>Yeni Tag Ekle</header>
        <form onSubmit={OnFormSubmit}>
          <div className="all_grid">
            <div className="grid_items">
              <div className="input-group">
                İsim{" "}
                <input
                  onChange={OnChangeinp1}
                  value={inp1}
                  type="text"
                  placeholder="point name"
                />
              </div>
              <div className="input-group">
                Adres{" "}
                <input
                  onChange={OnChangeinp2}
                  value={inp2}
                  type="number"
                  placeholder="point address"
                />
              </div>
              <div className="input-group">
                Adres detayları{" "}
                <input
                  onChange={OnChangeinp3}
                  value={inp3}
                  type="number"
                  placeholder="point address detail"
                />
              </div>
            </div>
            <div className="grid_items">
              <div className="input-group">
                DB numarası{" "}
                <input
                  onChange={OnChangeinp4}
                  value={inp4}
                  type="number"
                  placeholder="db number"
                />
              </div>
              <div className="input-group">
                Tip <select id="add_new_point_select_module"></select>
              </div>
              <div className="input-group">
                Data Tipi <select id="add_new_point_select_module"></select>
              </div>
            </div>
            <div className="grid_items">
              <div className="input-group">
                PLC{" "}
                <select name="" id="add_new_point_select_type">
                  <ul style={{ display: "none" }}>
                    <li>Flag</li>
                    <li>Çıktı</li>
                    <li>Girdi</li>
                    <li>DataBlock</li>
                  </ul>
                </select>
              </div>
              <div className="input-group">
                Kanal
                <select id="add_new_point_select_type">
                  <ul style={{ display: "none" }}>
                    <li>Uint</li>
                    <li>String</li>
                    <li>Double</li>
                    <li>Bool</li>
                    <li>Single</li>
                  </ul>
                </select>
              </div>
              <div className="input-group">
                Formül{" "}
                <input type="text" onChange={OnChangeinp5} value={inp5} />{" "}
              </div>
            </div>
            <div className="grid_items">
              <div className="input-group">
                {" "}
                Birim
                <input onChange={OnChangeinp6} value={inp6} type="text" />
              </div>
              <div className="input-group">
                Modül <select id="add_new_point_select_module"></select>
              </div>
            </div>
          </div>

          <div className="btn-group">
            <button type="submit" onClick={close_add_pop_up}>
              İptal <i class="fa-solid fa-ban"></i>
            </button>
            <button>
              Ekle <i class="fa-solid fa-check"></i>
            </button>
          </div>
        </form>
      </div>
      <div className="edit_point_pop_up">
        <header>Tag'i Düzenle</header>
        <form onSubmit={onEditFormSubmit}>
          <div className="all_grid">
            <div className="grid_items">
              <div className="input-group">
                ID{" "}
                <input
                  value={edit_id || ''}
                  type="text"
                  readOnly
                  style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
                />
              </div>
              <div className="input-group">
                Okunur Adı{" "}
                <input
                  value={edit_original_name || ''}
                  type="text"
                  readOnly
                  style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
                />
              </div>
              <div className="input-group">
                İsim{" "}
                <input
                  onChange={OnChangeinp1_1}
                  value={edit_point_name}
                  type="text"
                  placeholder="point name"
                />
              </div>
              <div className="input-group">
                Tag Açıklaması{" "}
                <input
                  onChange={OnChangeinp1_2}
                  value={edit_point_name2}
                  type="text"
                  placeholder="tag description"
                />
              </div>
              <div className="input-group">
                Tag Decimal{" "}
                <input
                  onChange={OnChangeinp1_3}
                  value={edit_point_decimal}
                  type="text"
                  placeholder="tag decimal"
                />
              </div>
              <div className="input-group">
                Adres{" "}
                <input
                  onChange={OnChangeinp2_2}
                  value={edit_point_address}
                  type="number"
                  placeholder="point address"
                />
              </div>
              <div className="input-group">
                Adres Detayları{" "}
                <input
                  onChange={OnChangeinp3_3}
                  value={edit_point_address2}
                  type="number"
                  placeholder="point address detail"
                />
              </div>
            </div>
            <div className="grid_items">
              <div className="input-group">
                DB Numarası{" "}
                <input
                  onChange={OnChangeinp4_4}
                  value={edit_point_db_number}
                  type="number"
                  placeholder="db number"
                />
              </div>
              <div className="input-group">
                Tip <select id="add_new_point_select_module"></select>
              </div>
              <div className="input-group">
                Data Tipi <select id="add_new_point_select_module"></select>
              </div>
            </div>
            <div className="grid_items">
              <div className="input-group">
                Totalizer:
                <button
                  onClick={async (e) => {
                    e.preventDefault();
                    let s =
                      activeTagId !== null &&
                      props.totalizer_tags.some(
                        (item) => String(item.tagId) === String(activeTagId)
                      );
                    if (!s) {
                      try {
                        const req_ = await axiosInstance.post('/tags/AddTagForTotalizer', {
                          CompanyId: String(props.temp_com_id),
                          tagId: String(activeTagId),
                          value: "1",
                          companyId: props.temp_com_id
                        });

                        if (req_.status === 200) {
                          console.log(req_.data);
                          await Store.dispatch(setTotalizerTags(req_.data));
                        }
                      } catch (err) {
                        console.log(err);
                      }
                    } else {
                      try {
                        const req_ = await axiosInstance.post('/tags/DeleteTagForTotalizer', {
                          tagId: String(activeTagId),
                          companyId: props.temp_com_id
                        });

                        if (req_.status === 200) {
                          console.log(req_.data);
                          await Store.dispatch(setTotalizerTags(req_.data));
                        }
                      } catch (err) {
                        console.log(err);
                      }
                    }
                  }}
                  className="add_TOTALIZER_BTN"
                >
                  {activeTagId !== null &&
                    props.totalizer_tags.some(
                      (item) => String(item.tagId) === String(activeTagId)
                    )
                    ? "1"
                    : "0"}
                </button>
              </div>
              <div className="input-group">
                Kanal
                <select id="add_new_point_select_type">
                  <ul style={{ display: "none" }}>
                    <li>Uint</li>
                    <li>String</li>
                    <li>Double</li>
                    <li>Bool</li>
                    <li>Single</li>
                  </ul>
                </select>
              </div>
              <div className="input-group">
                Formül{" "}
                <input
                  type="text"
                  onChange={OnChangeinp5_5}
                  value={edit_point_formula}
                />{" "}
              </div>
            </div>
            <div className="grid_items">
              <div className="input-group">
                {" "}
                Birim
                <input
                  onChange={OnChangeinp6_6}
                  value={edit_birim}
                  type="text"
                />
              </div>
              <div className="input-group">
                Modül <select id="add_new_point_select_module"></select>
              </div>
              <div
                onClick={async (e) => {
                  e.preventDefault();
                  let s =
                    activeTagId !== null &&
                    props.tags_for_trend_page.some(
                      (item) => item.tagId === Number(activeTagId)
                    );
                  if (!s) {
                    let tagId_ = activeTagId;
                    let tagName_ = "";
                    props.tag_list.forEach((a) => {
                      if (a.tagId === activeTagId) {
                        tagName_ = a.tagName;
                      }
                    });
                    let newArray = props.tags_for_trend_page;
                    newArray.push({
                      tagId: Number(tagId_),
                      tagName: tagName_,
                    });

                    try {
                      const req_ = await fetch(
                        "https://app-rmmsapi.azurewebsites.net/api/tags/AddTagForTrend",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                          },
                          method: "POST",
                          body: JSON.stringify({
                            TagId: Number(tagId_),
                            TagName: tagName_,
                            companyId:String(props.temp_com_id)
                          }),
                        }
                      );

                      const response = await req_.json();

                      if (req_.status === 200) {
                        console.log(response);
                        await Store.dispatch(set_tags_for_trend_page(response));
                      }
                    } catch (err) {
                      console.log(err);
                    }
                  } else {
                    let tagId_ = activeTagId;

                    try {
                      const req_ = await fetch(
                        "https://app-rmmsapi.azurewebsites.net/api/tags/DeleteTagForTrend",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                          },
                          method: "POST",
                          body: JSON.stringify({ TagId: Number(tagId_) }),
                        }
                      );

                      const response = await req_.json();

                      if (req_.status === 200) {
                        console.log(response);
                        await Store.dispatch(set_tags_for_trend_page(response));
                      }
                    } catch (err) {
                      console.log(err);
                    }
                  }
                }}
                style={{
                  borderBottom: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "24px",
                  userSelect: "none",
                  cursor: "pointer",
                }}
                id={
                  activeTagId !== null &&
                    props.tags_for_trend_page.some(
                      (item) => item.tagId === Number(activeTagId)
                    )
                    ? "mark_as_trendTag_active"
                    : "mark_as_trendTag"
                }
                className="input-group"
              >
                {activeTagId !== null &&
                  props.tags_for_trend_page.some(
                    (item) => item.tagId === Number(activeTagId)
                  )
                  ? "Trend Tag'i Olarak Ayarlandı"
                  : "Trend Tag'i Olarak Ayarla"}{" "}
                <i
                  style={{ marginLeft: "12px" }}
                  className="fa-solid fa-chart-line"
                ></i>
              </div>
            </div>
          </div>

          <div className="btn-group">
            <button
              type="button"
              onClick={(e) => {
                close_edit_pop_up();
                Set_activeTagId(null);
              }}
            >
              İptal <i class="fa-solid fa-ban"></i>
            </button>
            <button>
              Onay <i class="fa-solid fa-check"></i>
            </button>
          </div>
        </form>
      </div>
      <section
        style={{
          overflowY: "auto",
          overflowX: "none",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
        className="point_section"
      >
        <h1>
          <div onClick={open_add_pop_up}>
            Yeni Tag <i className="fa fa-plus"></i>
          </div>{" "}
          {(filtre_tagName !== "" ||
            filtre_tagAddress !== "" ||
            filtre_tagId !== "" ||
            filtre_tagType !== "") && (
              <button
                onClick={() => {
                  Set_filtre_tagName("");
                  Set_filtre_tagAddress("");
                  Set_filtre_tagId("");
                  Set_filtre_tagType("");
                  Set_render_state(props.tag_list);
                }}
                className="clear_searching_point"
              >
                Aramayı Temizle
              </button>
            )}{" "}
        </h1>
        <div className="table_point_top">
          <div className="row">
            <span>Tag İsmi</span>
            <span>Tag Tipi</span>
            <span>Tag Adresi</span>
            <span>Tag Id</span>
            <span>Detaylar</span>
            <span style={{ opacity: "0" }}></span>
          </div>
          <div className="row">
            <span>
              <input
                type="text"
                value={filtre_tagName}
                onChange={onChangeFiltrelemeValue}
              />
              <i
                onClick={() => {
                  var newdata = [];
                  render_state.forEach((item, index) => {
                    if (String(item.tagName).includes(filtre_tagName)) {
                      newdata.push(item);
                    }
                  });
                  Set_render_state(newdata);
                }}
                style={{ marginLeft: "10px", marginTop: "4px" }}
                class="fa-solid fa-filter"
              ></i>
            </span>
            <span>
              <input
                type="text"
                value={filtre_tagType}
                onChange={onChangeFiltrelemeValue4}
              />
              <i
                onClick={() => {
                  var newdata = [];
                  render_state.forEach((item, index) => {
                    if (String(item.tagType).includes(filtre_tagName)) {
                      newdata.push(item);
                    }
                  });
                  Set_render_state(newdata);
                }}
                style={{ marginLeft: "10px", marginTop: "4px" }}
                class="fa-solid fa-filter"
              ></i>
            </span>
            <span>
              <input
                type="text"
                value={filtre_tagAddress}
                onChange={onChangeFiltrelemeValue2}
              />
              <i
                onClick={() => {
                  var newdata = [];
                  render_state.forEach((item, index) => {
                    if (String(item.tagAddress).includes(filtre_tagAddress)) {
                      newdata.push(item);
                    }
                  });
                  Set_render_state(newdata);
                }}
                style={{ marginLeft: "10px", marginTop: "4px" }}
                class="fa-solid fa-filter"
              ></i>
            </span>
            <span>
              <input
                type="text"
                value={filtre_tagId}
                onChange={onChangeFiltrelemeValue3}
              />
              <i
                onClick={() => {
                  var newdata = [];
                  render_state.forEach((item, index) => {
                    if (String(item.tagId).includes(filtre_tagId)) {
                      newdata.push(item);
                    }
                  });
                  Set_render_state(newdata);
                }}
                style={{ marginLeft: "10px", marginTop: "4px" }}
                class="fa-solid fa-filter"
              ></i>
            </span>
            <span>
              <i
                style={{ marginLeft: "10px", marginTop: "4px" }}
                class="fa-solid fa-circle-info"
              ></i>
            </span>
          </div>
        </div>
        <div className="table_point_bottom">
          {render_state
            ? render_state.map((item, index) => {
              if (item.tagId === "60") console.log(item);
              var page_number = tag_page_number;
              var index_ = index;
              var aralık_alt = (page_number - 1) * 10;
              var aralık_top = page_number * 10;
              if (index_ >= aralık_alt && index_ < aralık_top) {
                return (
                  <div id={item.tagId} className="row">
                    <span>{item.tagName}</span>
                    <span>{item.tagType}</span>
                    <span>{item.tagAddress}</span>
                    <span>{item.tagId}</span>

                    <span className="chgdf">
                      <Link
                        to={path}
                        onClick={() => {
                          detail_pop_up_active(item);
                        }}
                      >
                        Detay <i className="fa fa-arrow-right"></i>
                      </Link>
                    </span>
                    <span className="edit_btns_point">
                      <button
                        style={{
                          pointerEvents: !tag_yazma_control ? "none" : "all",
                        }}
                        disabled={!tag_yazma_control}
                        onClick={(e) => {
                          open_edit_pop_up(e);
                          Set_activeTagId(item.tagId);
                        }}
                      >
                        Düzenle
                      </button>
                      <button
                        style={{
                          pointerEvents: !tag_silme_control ? "none" : "all",
                        }}
                        disabled={!tag_silme_control}
                        onClick={(e) => {
                          var confirm_ = window.confirm(
                            item.tagName +
                            " adlı tag'i silmek istediğinize emin misiniz?"
                          );
                          if (confirm_) {
                            Store.dispatch(
                              remove_points(
                                e.target.parentElement.parentElement.id
                              )
                            );
                            removetag(e);
                          }
                        }}
                      >
                        Sil
                      </button>
                      <button
                        style={{
                          pointerEvents: !tag_yazma_control ? "none" : "all",
                        }}
                        type="button"
                        disabled={!tag_yazma_control}
                        className="add_flow_btn"
                        onClick={() => {
                          Setflowcontrol(true);
                          let div_ = document.querySelector(".alarmPopup");
                          div_.classList.toggle("alarmPopup_active");
                          div_.id = item.tagId;

                          let message = "";
                          if (props.alarms && props.alarms.length > 0) {
                            const filteredAlarms = props.alarms.filter(
                              (x) => String(x.tagId) === String(item.tagId)
                            );
                            if (filteredAlarms.length > 0) {
                              message = filteredAlarms.map(
                                (x) => x.message
                              )[0];

                              if (message) {
                                console.log("Alarm mesajı:", message);
                              }
                            }
                          }

                          if (props.tag_list && props.tag_list.length > 0) {
                            const filteredTags = props.tag_list.filter(
                              (x) => String(x.tagId) === String(item.tagId)
                            );

                            if (filteredTags.length > 0) {
                              console.log(filteredTags
                              );
                              let formula = filteredTags.map(
                                (x) => x.tagFormula
                              )[0];
                              let message = filteredTags.map(
                                (x) => x.alarm
                              )[0];
                              console.log(message);

                              if (formula) {
                                formula = JSON.parse(formula);
                                let op = formula.operator;
                                let value = formula.value;
                                Set_alarmP_value(String(value));
                                setSelectedOperator(String(op));
                                Set_alarmP_text(message)
                                console.log("Formül bilgisi:", formula);
                              }
                            }
                          }

                          // console.log("FORMULA : ", formula);

                          // if (message !== null) Set_alarmP_text(message);
                          // // document
                          // //   .querySelector(".point_section")
                          // //   .classList.toggle("point_section_blur");
                        }}
                      >
                        Alarm <i class="fa-solid fa-bell"></i>
                      </button>
                    </span>
                  </div>
                );
              }
            })
            : ""}
          <div className="bottom_arrows">
            <div
              onClick={() => {
                if (tag_page_number >= 2) {
                  Set_tag_page_number((prevNumber) => prevNumber - 1);
                }
              }}
              className="left_arrow left_arrow_changex-45"
            >
              <i className="fa fa-arrow-left"></i>
            </div>
            <span
              style={{
                width: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
              className="page_number"
            >
              <p style={{ margin: "0 9px" }}>{tag_page_number}</p>/
              <p style={{ margin: "0 9px" }}>
                {Math.floor(Number(render_state.length) / 10) + 1}
              </p>
            </span>
            <div
              onClick={() => {
                if (
                  Math.floor(Number(render_state.length) / 10) + 1 >
                  tag_page_number
                ) {
                  Set_tag_page_number((prevNumber) => prevNumber + 1);
                }
              }}
              className="right_arrow right_arrow_changex-45"
            >
              <i className="fa fa-arrow-right"></i>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
const MapStateToProps = (state) => {
  return {
    tag_list: state.project_reducer.tag_list,
    tags_for_trend_page: state.project_reducer.tags_for_trend_page,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    userId: state.auth_reducer.user_id,
    totalizer_tags: state.project_reducer.totalizer_tags,
    alarms: state.project_reducer.alarms,
    com_id: state.project_reducer.company_id,
    temp_com_id: state.project_reducer.temp_com_id

  };
};
export default connect(MapStateToProps)(Point);
